/* src/app/components/search-bar/search-bar.component.scss */
ion-searchbar {
  transition:
    background 0.3s,
    border 0.3s,
    border-radius 0.3s,
    box-shadow 0.3s;
  margin-bottom: 18px;
}
ion-searchbar.custom-searchbar {
  border: 1px solid #949494;
  border-radius: 30px;
  color: #949494;
  --icon-color: #949494;
  --placeholder-color: #949494;
  --placeholder-font-weight: 400;
}
ion-searchbar.custom-searchbar ion-icon {
  color: #949494;
}
/*# sourceMappingURL=search-bar.component-K5AER7P6.css.map */
